import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import TargetChart from "../../charts/TargetChart/TargetChart";
import { defaultTargetChartWidgetData } from "./DefaultTargetChartWidgetData";

function getSeries(data){
  let bars
  let dots
  for(let k in data.series.barsData){
    bars = data.series.barsData[k]
    break;
  }
  for(let k in data.series.dotsData){
    dots = data.series.dotsData[k]
    break;
  }
  return [bars, dots]
}

const TargetChartWidget = ({ endpoint, datasource,requestHandler, title, filter, profileId, solutionId, subtitle,
  widgetClassName, chartClassName, options = {}, locale = navigator.language, showTitle = true, showSubtitle=true, disableRls=false, targetCircle, passedItems = null}) => {

  const [data, setData] = useState(defaultTargetChartWidgetData);
  const [error, setError] = useState("");

  useEffect(() => {
    if(!passedItems)
    requestHandler(endpoint, datasource, filter, profileId, solutionId, setData, setError, disableRls);
  }, [endpoint, datasource, filter, profileId, solutionId, disableRls]);


  const series = getSeries(passedItems ? passedItems : data);

  let newWidgetClassName="shadow-sm h-100 " + widgetClassName

    return (
      <Card border="light" className={`${newWidgetClassName}`}>
      <Card.Body>
        <Row className="h-25 d-block d-xl-flex align-items-center">
          {(showTitle) &&
            <Col xs={12} className="px-xl-0">
              <h5 className="mb-2">{error ? "Service unavailable" : title}</h5>
            </Col>
          }
          {showSubtitle && <Col xs={12} className="d-flex align-items-center justify-content-xl-center px-xl-0">
            <h6 className="mt-1 mb-1">{subtitle}</h6>
          </Col>}
          <Col xs={12} className="text-xl-center d-flex align-items-center justify-content-xl-center mb-3 mb-xl-0">
            <TargetChart
              labels={passedItems ? passedItems.labels : data.labels}
              series={series}
              chartClassName={chartClassName}
              options={options}
              targetCircle={targetCircle}
              locale={locale}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default TargetChartWidget;